export const getFundsMap = (clientFundsData: any, idToShortCode: boolean = true) => {
  if (!clientFundsData) return {};
  const funds = clientFundsData.map((i) => i?.funds).flat();
  let fundsMap = funds.reduce((acc, curr) => {
    if (idToShortCode) {
      acc[curr.accountId] = curr.shortCode;
    } else {
      acc[curr.shortCode] = curr.accountId;
    }
    return acc;
  }, {});
  return fundsMap;
};

export const transformInventoryData = (data: any[], clientFundsData: any) => {
  const funds = getFundsMap(clientFundsData);
  const seenSecurityIds = new Set<string | number>();
  const transformedData = (data || [])
    .map((item) => {
      return {
        name: item?.securityName,
        id: item?.bnySecurityId,
        ticker: item?.securityTicker,
        securityId: item?.bnySecurityId,
        issueCountry: item?.securityIssueCountry,
        isin: item?.securityIsin,
        sedol: item?.securitySedol,
        availableQuantity: item?.availableQuantity,
        divRate: item?.divRate,
        recordDate: item?.recordDate,
        availableNotional: item?.availableQuantity * item?.securityMarketPrice * item?.fxRate,
        price: item?.securityMarketPrice,
        underlyingPrice: item?.securityMarketPrice * item?.fxRate,
        underlyingCurrency: item?.underlyingCurrency,
        exchangeRate: item?.fxRate,
        availableNotionalUsd: item?.availableQuantity * item?.securityMarketPrice,
        basketQuantity: 0,
        basketNotional: 0,
        basketNotionalUsd: 0,
        ccy: item?.inputCurrency,
        location: item?.location,
        shortCode: item?.shortCode,
        inputCurrency: item?.inputCurrency,
        fund: funds[item?.fundId],
      };
    })
    .filter((row) => {
      const id = row.securityId;
      if (id == null || seenSecurityIds.has(id)) return false;
      seenSecurityIds.add(id);
      return true;
    });

  return transformedData;
};

export const transformAvailableBasketsData = (data: any[]) => {
  const transformedData = (data || []).map((item) => ({
    ...item,
    name: item?.basketName,
    client: item?.clientId,
    fund: item?.fundId,
    createdBy: item?.createdByUser,
    createdDate: item?.createdDate,
    modifiedBy: item?.modifiedByUser,
    lastUpdate: item?.modifiedDate,
  }));

  return transformedData;
};

export const getClientAndFundIds = (data: any, clientFundsData: any) => {
  const funds = getFundsMap(clientFundsData, false);
  if (!data || !data?.basketItemDetails?.basketItems) return { clientId: null, fundId: null };
  const clientId = data.clientId;
  const basketItems = data.basketItemDetails.basketItems;
  const fundIds = basketItems.map((i) => funds[i.fundId]);
  //For Day 2 use the fundIds array for mapping multiselect fund selection
  return { clientId, fundId: fundIds[0] };
};

export const isDraftBasketOpen = (
  draftBasketDetails: any,
  basketInputData: any,
  clientFundsData: any,
) => {
  const funds = getFundsMap(clientFundsData);
  return (
    draftBasketDetails?.clientId !== basketInputData?.clientId ||
    draftBasketDetails?.basketItemDetails?.basketItems?.[0]?.fundId !==
      funds[basketInputData?.fundId]
  );
};
